import { createContext, ReactNode, useContext } from 'react';

export interface YearContextInterface {
	year: number;
}

// eslint-disable-next-line react-refresh/only-export-components
export const YEAR_CONTEXT_DEFAULT: YearContextInterface = {
	year: 2024
};

const YearContext = createContext(YEAR_CONTEXT_DEFAULT);

// eslint-disable-next-line react-refresh/only-export-components
export function useYear() {
	return useContext<YearContextInterface>(YearContext);
}

export function YearProvider({
	children,
	year
}: {
	children: ReactNode;
	year?: number;
}) {
	const yearValue = year ?? YEAR_CONTEXT_DEFAULT.year;

	return (
		<YearContext.Provider value={{ year: yearValue }}>
			{children}
		</YearContext.Provider>
	);
}
